<div class="pme-container">
  <div class="pme-row display-utils-row">
    <div class="pme-col display-utils-gt-sm-flex-50" >
      <main class="display-utils-col display-utils-gap-40">
        <pme-hero
          *ngIf="this.selfAttendanceHeroData"
          type="{{this.selfAttendanceHeroData.type}}"
          title="{{this.selfAttendanceHeroData.title}}">
          <p *ngFor="let content of this.selfAttendanceHeroData.contents" [innerHtml]="content"></p>
        </pme-hero>

        <pme-invoice
          *ngIf="this.selfAttendanceData && this.selfAttendanceHeroData?.showInvoice"
          [bankBilletData]="this.selfAttendanceData.bankBilletData"
          [pixData]="this.selfAttendanceData.pixData"
          [creditCardData]="this.selfAttendanceData.creditCardData"
          [hideBankBilletMessage]="this.hideInvoiceBankBilletMessage"
          [account]="this.selfAttendanceData.account"
          [contract]="this.selfAttendanceData.contract"
          [isInvestigate]="this.selfAttendanceData.isInvestigate"
          (onSuccessButtonClick)="this.onSuccessClick('primary')">
        </pme-invoice>

        <div class="display-utils-row display-utils-center" *ngIf="this.selfAttendanceHeroData">
          <a mat-flat-button class="noneTextTrasform" color="primary" href="{{this.redirectURL}}">{{this.selfAttendanceHeroData.buttonName}}</a>
        </div>
      </main>
    </div>
  </div>
</div>
